import request from '@/utils/request';

/**市场渠道配置 */

//获取渠道配置列表
export function getChannelConfigList (data) {
    return request({
        url: '/contract/onlineMarketNew/selectChannel',
        method: 'post',
        headers: { repeatSubmit: false },
        data
    })
}

//获取渠道配置列表
export function getCityList (data) {
    return request({
        url: '/contract/onlineMarketNew/selectCity',
        method: 'post',
        headers: { repeatSubmit: false },
        data
    })
}


//新增渠道配置
export function addChannelConfig (data) {
    return request({
        url: "/contract/onlineMarketNew/addChannel",
        method: 'post',
        headers: { repeatSubmit: false },
        data
    })
}


//编辑渠道配置
export function editChannelConfig (data) {
    return request({
        url: "/contract/onlineMarketNew/updateChannel",
        method: 'post',
        headers: { repeatSubmit: false },
        data: { ...data, flag: 0 }
    })
}

//删除渠道配置
export function deleteChannelConfig (data) {
    return request({
        url: "/contract/onlineMarketNew/updateChannel",
        method: 'post',
        headers: { repeatSubmit: false },
        data: { ...data, flag: 1 }
    })
}


//修改渠道配置状态
export function modifyChannelConfigStatus (data) {
    return request({
        url: "/contract/onlineMarketNew/updateChannel",
        method: 'post',
        headers: { repeatSubmit: false },
        data: { ...data, flag: 2 }
    })
}


//合并渠道
export function combineChannelConfig (data) {
    return request({
        url: '/contract/onlineMarketNew/combineChannel',
        method: 'post',
        data
    })
}
